import React from "react";
import { Grid, Typography } from "@mui/material";
import YesNoQuestion from "./components/YesNoQuestion";
import ChoiceQuestion from "./components/ChoiceQuestion";
import TextQuestion from "./components/TextQuestion";

const Answers = ({ category, questions, userId }) => {
  const renderAnswers = () => {
    if (!questions) {
      return <></>;
    }
    return questions.map((q, i) => {
      switch (q.questionType) {
        case "choice":
          return <ChoiceQuestion key={q?._id} questionData={q} userId={userId}/>;
        case "yesno":
            return <YesNoQuestion key={q?._id} questionData={q} userId={userId}/>;
        case "text":
            return <TextQuestion key={q?._id} questionData={q} userId={userId}/>;
        default:
          return <></>;
      }
    });
  };

  return <Grid container spacing={2}>{renderAnswers()}</Grid>;
};

export default Answers;
